module.exports = __webpack_public_path__ + "assets/2_3_2_IFOK_WIM_STUSTAINABILITY_Society_platform_for_svg_je.c97f28ec.svg";